export default __webpack_public_path__ + "static/shinsei-5c07dc929ed76d4a10b564051e3dc786.jpg";